import { ComponentStore } from '@ngrx/component-store';
import { inject, Injectable } from '@angular/core';
import { concatMap, filter, map, shareReplay, withLatestFrom } from 'rxjs/operators';
import { ICorrelation } from '@app/api/interfaces/correlation.interface';
import { Observable, of } from 'rxjs';
import equal from 'fast-deep-equal';
import { IGcComponentStore } from '@app/core/interfaces/gc-component-store.interface';
import { FLOATING_POPUP_DATA } from '@app/main/main-content/floating-popup-manager/providers/floating-popup-data.token';
import {
  IFpCorrelationSummaryState,
  initialFpCorrelationSummaryState,
} from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary/fp-correlation-summary.state';
import {
  FpCorrelationSummaryActionGetData,
  FpCorrelationSummaryActionGetDataSuccesses,
  FpCorrelationSummaryActions,
  FpCorrelationSummaryActionType,
} from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary/fp-correlation-summary.actions';
import { Store } from '@ngrx/store';
import { selectMainProjectId } from '@app/main/main-screen/store/main-selection/main-shared-selection/main-shared-selection.selectors';
import { IProject } from '@app/api/interfaces/project.interface';
import { selectProjectEntities } from '@app/main/main-screen/store/projects/projects.selectors';

@Injectable()
export class FpCorrelationSummaryStore
  extends ComponentStore<IFpCorrelationSummaryState>
  implements IGcComponentStore<FpCorrelationSummaryActions>
{
  public readonly data = inject<ICorrelation>(FLOATING_POPUP_DATA);
  protected readonly store = inject(Store);

  constructor() {
    super(initialFpCorrelationSummaryState);
  }

  public readonly date$ = this.select(s => s.date, { equal });
  public readonly data$ = this.select(s => s.data, { equal });

  // todo: do this functionality in the separated place
  public readonly viewMeasurementSystem$ = this.store.select(selectMainProjectId).pipe(
    filter((projectId): projectId is string => !!projectId),
    withLatestFrom(this.store.select(selectProjectEntities)),
    map(([projectId, projects]) => projects[projectId]),
    filter((project): project is IProject => !!project),
    map(project => project.viewMeasurementSystem),
    shareReplay(1)
  );

  public readonly loading$ = this.select(s => s.loading, { equal });

  public dispatch = this.effect((action$: Observable<FpCorrelationSummaryActions>) =>
    action$.pipe(
      concatMap(action => {
        switch (action.type) {
          case FpCorrelationSummaryActionType.GetData: {
            this.reducerGetData();
            this.effectGetData(action);
            break;
          }
          case FpCorrelationSummaryActionType.GetDataSuccesses: {
            this.reducerGetDataSuccesses(action);
            break;
          }
        }
        return of(action);
      })
    )
  );

  private reducerGetData() {
    this.patchState({
      loading: true,
    });
  }

  private reducerGetDataSuccesses(action: FpCorrelationSummaryActionGetDataSuccesses) {
    this.patchState({
      date: action.date,
      data: action.data,
      loading: false,
    });
  }

  private effectGetData(action: FpCorrelationSummaryActionGetData) {
    this.dispatch({
      type: FpCorrelationSummaryActionType.GetDataSuccesses,
      date: action.date,
      data: action.popupMainData,
    });
  }
}
